






























import { Component, Vue } from 'vue-property-decorator'
import { IBlogItem } from '../../../prismic'

function upsertMetaTag(attr: string, attrvalue: string, content: string, extraAttrs: string[][] = [], alwaysInsert: boolean = false) {
  let el: Element | null = document.querySelector(`meta[${attr}="${attrvalue}"]`)

  if (!el || alwaysInsert) {
    const elNew = document.createElement('meta')
    elNew.setAttribute(attr, attrvalue)

    if (el) {
      (el.parentNode as Element).insertBefore(elNew, el)
    } else {
      document.head.appendChild(elNew)
    }

    el = elNew
  }

  for (const extra of extraAttrs) {
    el.setAttribute(extra[0], extra[1])
  }

  el.setAttribute('content', content)
}

function setMetaTitle(title: string) {
  // Note: document title is set in router because it also sends tracking events

  if (!title) return

  upsertMetaTag('property', 'og:title', title)
  upsertMetaTag('name', 'twitter:title', title)
}

function setMetaImage(url: string) {
  if (!url) return

  // Seems that Facebook (no longer) supports multiple og:image tags so remove them and add the header image
  document.querySelectorAll('meta[property="og:image"]').forEach(x => x.remove())

  upsertMetaTag('property', 'og:image', url, [], true)
  // upsertMetaTag('property', 'og:image', url, [['og:image:width', '944'], ['og:image:height', '494']], true)

  upsertMetaTag('name', 'image', url)
  upsertMetaTag('itemprop', 'image', url)
  upsertMetaTag('name', 'twitter:image:src', url)
}

function setMetaDescription(desc: string) {
  if (!desc) return

  upsertMetaTag('name', 'description', desc)
  upsertMetaTag('itemprop', 'description', desc)
  upsertMetaTag('name', 'twitter:description', desc)
  upsertMetaTag('property', 'og:description', desc)
}

function setMetaUrl(url: string) {
  if (!url) return

  // url += '.html' // Facebook needs this or the og:url does not match the actual URL, and then it will scrape the page without html which isn't prerendered

  upsertMetaTag('property', 'og:url', url)
}

function setMetaType(type: string) {
  if (!type) return

  upsertMetaTag('property', 'og:type', type)
}

@Component({
  components: {
    FacebookLink: require('@/components/FacebookLink').default
  }
})
export default class BlogArticle extends Vue {
  get slug(): string {
    return this.$route.params.slug
  }

  get article(): IBlogItem {
    const article: IBlogItem = this.$store.state.prerender.blogArticles.find((x: IBlogItem) => x.data.slug === this.slug.replace('.html', ''))

    return article
  }

  get hero(): string {
    if (!this.article.data.hero) return ''

    return this.article.data.hero.url
  }

  created() {
    setMetaTitle(this.article.data.title)
    setMetaImage(this.article.data.hero.url)
    setMetaDescription(this.article.data.lead)
    setMetaUrl(`https://rekord.cloud/blog/${this.article.data.slug}`)
    setMetaType('article')
  }

  mounted() {
    this.$nextTick(() => {
      document.dispatchEvent(new Event('x-app-rendered'))
    })
  }
}
